


































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class FilterSelect extends Vue {
  filterState: boolean = false

  @Prop({type:Array,default:[]}) protected items!:Array <object>

}

